import { LayoutProvider } from './context/LayoutContext';
import { MessageProvider } from './context/MessageContext';
import { DeviceMetricsProvider } from './context/DeviceMetricsContext';
import { AppVersionProvider, useAppVersion } from './context/AppVersionContext';
import AppVersionUpdateDialog from './component/appversionupdate/AppVersionUpdateDialog';
import useAutoLogout from './hook/useAutoLogout';
import Routing from './routes/routes';

import { addLocale } from 'primereact/api';

import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
import Iconsax from 'iconsax-react'
import { pl } from "primelocale/js/pl.js";

const AppContent = () => {
  const { showUpdateDialog, handleReload } = useAppVersion();
  
  useAutoLogout();
  
  return (
    <>
      <MessageProvider>
        <LayoutProvider>
          <DeviceMetricsProvider>
            <Routing />
          </DeviceMetricsProvider>
        </LayoutProvider>
      </MessageProvider>
      <AppVersionUpdateDialog visible={showUpdateDialog} onReload={handleReload} />
    </>
  );
};

const App = () => {
  addLocale('pl', pl);  

  return (
    <AppVersionProvider>
      <AppContent />
    </AppVersionProvider>
  );
}

export default App;
